import TokenAnalyzer from "./TokenAnalyzer";

export default TokenAnalyzer;